import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ReviewsApiService } from '../../../services/reviews-api.service';
import { LimitOffsetPagination } from '../../../../../shared/models/limit-offset-pagination';
import { PaginatedVendorReviews } from '../../../../../shared/models/paginated-vendor-reviews';
import { RatingCount } from '../../../../../shared/models/rating-count';
import { TablePaginationComponent } from "../../../../../shared/components/table-pagination/table-pagination.component";
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/translations/language.service';

@Component({
  selector: 'app-review-page',
  imports: [CommonModule, TablePaginationComponent, TranslateModule],
  templateUrl: './review-page.component.html',
  styleUrl: './review-page.component.css'
})
export class ReviewPageComponent implements OnInit {

  apiService = inject(ReviewsApiService);
  languageService = inject(LanguageService);

  vendorReviews: PaginatedVendorReviews | undefined;

  reviewsSummary: RatingCount[] = [];

  pagination: LimitOffsetPagination = { limit: 10, offset: 0 };

  ratings = [
    { star: 5, count: 298, color: 'bg-green-500' },
    { star: 4, count: 140, color: 'bg-purple-400' },
    { star: 3, count: 40, color: 'bg-yellow-400' },
    { star: 2, count: 40, color: 'bg-blue-400' },
    { star: 1, count: 2, color: 'bg-orange-400' },
  ];

  colorMap: Record<number, string> = {
    5: 'bg-green-500',
    4: 'bg-purple-400',
    3: 'bg-yellow-400',
    2: 'bg-blue-400',
    1: 'bg-orange-400',
  };


  totalReviews = 320;

  ngOnInit(): void {
    this.getVendorReviews();
    this.getVendorReviewsSummary();
  }



  getVendorReviews(): void {
    this.apiService.getVendorReviews(this.pagination).subscribe((response: PaginatedVendorReviews) => {
      this.vendorReviews = response;
    });
  }

  getVendorReviewsSummary(): void {
    this.apiService.getVendorReviewsSummary().subscribe((response: RatingCount[]) => {
      this.reviewsSummary = response.sort((a, b) => b.rating - a.rating);

      this.ratings = this.reviewsSummary
        .filter(item => item.rating > 0)
        .map(item => ({
          star: item.rating,
          count: item.count,
          color: this.colorMap[item.rating] ?? 'bg-gray-300', // fallback color
        }));
    });
  }

  getRatingsSummary(data: RatingCount[] = this.reviewsSummary) {
    const totalCount = data.reduce((sum, item) => sum + item.count, 0);

    const weightedSum = data.reduce(
      (sum, item) => sum + item.rating * item.count,
      0
    );

    const average = totalCount > 0 ? weightedSum / totalCount : 0;

    return {
      totalCount,
      average,
    };
  }

  updatePagination(pagination: LimitOffsetPagination) {
    this.pagination = pagination;
    this.getVendorReviews();
  }

}
